var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.oH=require("moment");module.exports=$CLJS.oH;